import React from 'react'
import styled from 'styled-components'
import { useDispatch, useSelector } from 'react-redux'

import { Button, Tabs } from 'components'
import { FaSortAmountUpAlt, FaSortAmountUp, FaCheck } from 'react-icons/fa'

import { sortContext } from 'context'
import * as actionCreators from 'store/actions'

const Container = styled.div`
    background-color: var(--secondary-color);
    // width: var(--popout-width);
    width: fit-content;
    min-width: var(--popout-width);
    max-width: 17rem;
    font-size: var(--popout-font-size);
    padding: 0.5rem;
    border-radius: 5px;
    overflow: hidden;
    position: relative;
    margin-top: 0.5rem;
    box-shadow: var(--box-shadow);
    :focus{
        outline: none;
    }
`

const OptionsContainer = styled.div`
    display: grid;
    grid-template-columns: 47.5% 47.5%;
    grid-column-gap: 5%;
`

const Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 0 0.2rem 0;
`

const Title = styled.div`
    font-weight: bolder;
    font-size: 0.7rem;
    padding: 0 0 0 0.5rem;
    text-transform: uppercase;
    color: var(--secondary-accent-color);
`

const Icon = styled.div`
    color: ${props => props.color || 'var(--secondary-accent-color)'};
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.8rem;
`

const Row = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: 1rem 3rem 1fr 1rem;
    grid-column-gap: 0.5rem;
    padding: 0.5rem 0.5rem;
    background-color: var(--secondary-color);
    border-radius: 5px;
    cursor: pointer;
    :hover{
        filter: brightness(var(--brightness));
    }
`

const Text = styled.div`
    font-weight: bold;
    font-size: 0.8rem;
`


const buttonStyle = {
    backgroundColor: 'var(--secondary-color)', 
    boxShadowColor: 'transparent',
    fontWeight: 'bold',
    margin: '0.1rem 0',
    justifyContent: 'flex-start',
    padding: '0.5rem'
}

const selectedStyle = {
    ...buttonStyle,
    backgroundColor: 'var(--focus-color)',
}

const SortOptions = props => {
    const {
        pageID,
        closeHandler
    } = props;
    const debug = false;
    const dispatch = useDispatch()
    const uid = useSelector(state => state.auth.uid)
    const sessionId = useSelector(state => state.content.sessionId)
    const data = useSelector((state) => state.db.present.data && state.db.present.data.toJS())
    const page = data['pages'][pageID]
    const sort = { value: page['sort'] && page['sort']['value'], direction: page['sort'] && page['sort']['direction'] || 'ASCENDING' }

    const onSelect = (option, direction, disableClose) => {
        let updatedPage = {...page}
        updatedPage['sort'] = {value: sort['value'] === option && sort['direction'] === direction ? null : option, direction: direction}
        // closeHandler && !disableClose && closeHandler()
        debug && console.log('[SortOptions]', {sort: updatedPage['sort'], updatedPage})
        dispatch(actionCreators.updatePage(updatedPage, data, uid, sessionId))
    }

    const options = Object.values(sortContext).map(option => (
        // <Button text={option['title']} icon={option['icon']}
        //     styles={page['sort'] && page['sort'] === option['value'] ? selectedStyle : buttonStyle}
        //     onSelect={() => onSelect(option['value'], sort['direction'])}/>
        <Row onClick={() => onSelect(option['value'], sort['direction'])}>
            <Icon>{option['icon']}</Icon>
            <Text>{option['title']}</Text>
            <span/>
            {sort['value'] === option['value'] ? <FaCheck style={{ color: 'var(--focus-color)' }}/> : null}
        </Row>
    ))

    return (
        <Container>
            {/* Headers */}
            <Header>
                <Title>Sort</Title>
                <Button text='Clear' onSelect={() => onSelect(null,null)}
                    styles={{ margin: 0, color: 'var(--text-color)', fontWeight: 'bold', fontSize: '0.7rem', backgroundColor: 'var(--secondary-color)', boxShadowColor: 'transparent' }}/>
            </Header>

            {/* Options */}
            <Tabs onSelect={(tab) => onSelect(sort['value'], tab, true)} 
                options={{ASCENDING: 'Asc', DESCENDING: 'Desc'}} 
                icons={{ASCENDING: <FaSortAmountUp/>, DESCENDING: <FaSortAmountUpAlt/>}}
                selected={sort && sort['direction']}
                styles={{
                    main: {
                        width: '100%',
                        backgroundColor: 'var(--primary-accent-color)',
                        fontWeight: 'normal',
                        fontSize: '0.8rem',
                        margin: '0 0 0.2rem 0'
                    },
                    tab: {
                        width: null,
                        padding: '0.25rem',
                        fontWeight: 'normal',
                        fontSize: '0.8rem'
                    }
                }}/>

            {/* Main body */}
            {options}
        </Container>
    )
}

export default SortOptions